import SchoolIcon from "@mui/icons-material/School";
import { resources as Specializations } from "./Specializations";
import { resources as AdvancedSpecializations } from "./AdvancedSpecializations";
import { resources as AdvancedSpecializationSpecialists } from "./AdvancedSpecializationSpecialist";
import { resources as HealthcareCourses } from "./HealthcareCourses";
import { resources as Campaigns } from "./Campaigns";
import { resources as CampaignApplications } from "./CampaignApplications";
import { resources as CampaignApplicationDetails } from "./CampaignApplications/Show";
import { resources as HealthcareCampaign } from "./HealthcareCampaign";
import { resources as PostgraduateCourses } from "./PostgraduateCourses";
import { resources as PostgraduateCoursesFinalization } from "./PostgraduateCoursesFinalization";
import { resources as HealthcareCampaignApplication } from "./HealthcareCampaignApplication";
import { resources as Details } from "./HealthcareCampaignApplication/Details";
import { resources as ExamCommittiee } from "./ExamCommittiee";
import { resources as SpecializationsCurricula } from "./SpecializationsCurricula";
import { resources as TrainingBuildings } from "./TrainingBuildings";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <SchoolIcon />,
  name: "Специализанти",
  title: "Специализанти",
  subMenu: [
    Specializations,
    SpecializationsCurricula,
    TrainingBuildings,
    PostgraduateCourses,
    ExamCommittiee,
    Campaigns,
    CampaignApplications,
    CampaignApplicationDetails,
    AdvancedSpecializations,
    AdvancedSpecializationSpecialists,
    PostgraduateCoursesFinalization,
    Details,
    HealthcareCourses,
    HealthcareCampaign,
    HealthcareCampaignApplication,
  ],
};
